import { Tooltip } from "antd";
import React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";

const AdnToolTip = ({ title, color = "grey" }) => {
  return (
    <Tooltip title={title}>
      <InfoCircleOutlined style={{ marginLeft: "10px", color: color }} />
    </Tooltip>
  );
};

export default AdnToolTip;
